import React from 'react';
import Biillings from '../../features/billings';

const BillingsPage = () => {
  return <Biillings />;
};

export default BillingsPage;
